"use strict";function startRealtimeTracing$(a){return ddSdk_1.ddSdk.invokeAPI(apiName,a)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startRealtimeTracing$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.realm.startRealtimeTracing";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.13"},_a)),exports.startRealtimeTracing$=startRealtimeTracing$,exports.default=startRealtimeTracing$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/realm/startRealtimeTracing.js
// module id = 985
// module chunks = 106